import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const RiskModal = ({ openRisk, onClose }) => {
  return (
    <Dialog open={Boolean(openRisk)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem" }}>
        {openRisk?.title} — {openRisk?.level}
      </DialogTitle>
      <DialogContent dividers>
        <h4>Description</h4>
        <Typography sx={{ fontSize: "0.9rem", color: "#4b5563" }}>
          {openRisk?.description}
        </Typography>
        <h4>Rationale</h4>
        <Typography sx={{ fontSize: "0.9rem", color: "#4b5563" }}>
          {openRisk?.rationale}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          size="small"
          sx={{ textTransform: "none", borderRadius: "999px", px: 2.5 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RiskModal;
